import {createAction, createReducer} from 'redux-act'
import l8n from 'l8n'

export const REDUCER = 'integration'
const NS = `@@${REDUCER}/`

export const accessRequest = createAction(`${NS}ACCESS_REQUESTED`)
export const passwordResetRequest = createAction(`${NS}PASSWORD_RESET_REQUESTED`)

export const change = createAction(`${NS}CHANGE`)

const initialState = {}

const openJivoChatAndSendMessage = (text) => {
  window.jivo_api.open()
  window.jivo_api.sendMessage(text)
}

const sendChatMessage = (text) => {
  if (window.jivo_api) {
    openJivoChatAndSendMessage(text);
  } else {
    window.jivo_onLoadCallback = () => {
      openJivoChatAndSendMessage(text)
    }
  }
}

export const requestAccess = () => (dispatch) => {
  dispatch(accessRequest())
  sendChatMessage(l8n['integration.access.message.request'])
}

export const restorePassword = () => (dispatch) => {
  dispatch(passwordResetRequest())
  sendChatMessage(l8n['integration.access.message.password'])
}

export default createReducer(
  {
    [accessRequest]: (state) => ({ ...state }),
    [passwordResetRequest]: (state) => ({ ...state }),
  },
  initialState
)



// WEBPACK FOOTER //
// ./src/ducks/integration.js